__turbopack_context__.v({
  "actionButton": "b7XtRG_actionButton",
  "actions": "b7XtRG_actions",
  "closeButton": "b7XtRG_closeButton",
  "content": "b7XtRG_content",
  "description": "b7XtRG_description",
  "dialog": "b7XtRG_dialog",
  "dialogActions": "b7XtRG_dialogActions",
  "dialogDescription": "b7XtRG_dialogDescription",
  "dialogMeta": "b7XtRG_dialogMeta",
  "dialogTitle": "b7XtRG_dialogTitle",
  "gpcStatus": "b7XtRG_gpcStatus",
  "header": "b7XtRG_header",
  "heading": "b7XtRG_heading",
  "manageButton": "b7XtRG_manageButton",
  "outline": "b7XtRG_outline",
  "policyLink": "b7XtRG_policyLink",
  "primary": "b7XtRG_primary",
  "privacyChoicesReset": "b7XtRG_privacyChoicesReset",
  "privacyOptionsIcon": "b7XtRG_privacyOptionsIcon",
  "privacyStatus": "b7XtRG_privacyStatus",
  "root": "b7XtRG_root",
  "switchControl": "b7XtRG_switchControl",
  "switchCopy": "b7XtRG_switchCopy",
  "switchDescription": "b7XtRG_switchDescription",
  "switchInput": "b7XtRG_switchInput",
  "switchInputLocked": "b7XtRG_switchInputLocked",
  "switchLabel": "b7XtRG_switchLabel",
  "switchList": "b7XtRG_switchList",
  "switchLock": "b7XtRG_switchLock",
  "switchNote": "b7XtRG_switchNote",
  "switchRow": "b7XtRG_switchRow",
  "textButton": "b7XtRG_textButton",
});
